import { Component, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-input',
  imports: [MatInputModule, ReactiveFormsModule, MatDatepickerModule],
  template: `
     <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{to.label}}</mat-label>
                <input matInput [matDatepicker]="pickerStart" [formControl]="formControl" mask="00-00-0000"
                    [min]="minDate" [max]="maxDate">
                <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
                <mat-datepicker #pickerStart></mat-datepicker>
            </mat-form-field>
  `,
})
export class CustomFormlyDate extends FieldType<FieldTypeConfig> {
  minDate: Date = new Date(1900, 0, 1);
  maxDate: Date = new Date(2100, 11, 31);

  ngOnInit() {
    if (this.props['minDate']) {
      this.minDate = new Date(this.props['minDate']);
    }
    if (this.props['maxDate']) {
      this.maxDate = new Date(this.props['maxDate']);
    }

    const currentValue = this.formControl.value;
    if (currentValue && typeof currentValue === 'string') {
      const parts = currentValue.split('-');
      if (parts.length === 3) {
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; 
        const day = parseInt(parts[2], 10);
        const dateValue = new Date(year, month, day);
        if (!isNaN(dateValue.getTime())) {
          this.formControl.setValue(dateValue);
        }
      }
    }
  }
}